const phoneNumberFormatter = (numberString) => {
  numberString = numberString.replace(/\D/g, '')
  if (numberString.length > 9) {
    numberString = numberString.substring(0, 9)
  }
  return numberString
}

export default phoneNumberFormatter
